export const classes = {
  skeletonItem: 'mb-3 shadow-card rounded-2xl overflow-hidden',
  skeleton:
    'py-8 w-full bg-gradient-to-br from-white/90 via-white/70 to-orange-100/100 dark:bg-none dark:bg-white/[0.04]',
};

export const styles = {
  skeleton: (delay: number) => ({
    '&:after': {
      animationDelay: `${delay}s`,
      animationDuration: '1.2s',
      background:
        'linear-gradient(90deg, transparent, hsla(32, 97%, 90%, 0.5), transparent)',
    },
  }),
};
